import React, { useState, useEffect, useCallback } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { RgbaColorPicker } from 'react-colorful';
import { stringToRgba, rgbaToString, RGBAColor } from '@/components/ColorPickerRGBA';

interface ColorEditorPopoverProps {
  children: React.ReactNode;
  colorName: string;
  currentColor: string;
  onSave: (newColor: string) => void;
}

export const ColorEditorPopover: React.FC<ColorEditorPopoverProps> = ({
  children,
  colorName,
  currentColor,
  onSave
}) => {
  const [tempColor, setTempColor] = useState<RGBAColor>(stringToRgba(currentColor));

  useEffect(() => {
    const parsed = stringToRgba(currentColor);
    setTempColor(parsed);
  }, [currentColor]);

  const handleColorChange = (newColor: RGBAColor) => {
    setTempColor(newColor);
    onSave(rgbaToString(newColor));
  };

  // Travar scroll do painel ao abrir o color picker
  const handleOpenChange = useCallback((open: boolean) => {
    const sheetContent = document.querySelector('[data-side="right"]');
    if (sheetContent instanceof HTMLElement) {
      sheetContent.style.overflowY = open ? 'hidden' : 'auto';
    }
  }, []);

  return (
    <Popover onOpenChange={handleOpenChange} modal={false}>
      <PopoverTrigger asChild>
        {children}
      </PopoverTrigger>
      
      <PopoverContent 
        side="top"
        align="center"
        sideOffset={8}
        collisionPadding={16}
        className="w-[240px] p-4 rounded-xl shadow-[0_16px_40px_rgba(0,0,0,0.15)] border-0 z-[99999] bg-background"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="space-y-2.5">
          <div className="text-center">
            <h3 className="text-sm font-semibold text-foreground">
              {colorName}
            </h3>
          </div>

          <div className="flex justify-center">
            <RgbaColorPicker 
              color={tempColor}
              onChange={handleColorChange}
              style={{ width: '200px', height: '160px' }}
            />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
